import { NgModule } from '@angular/core';

import { MomentDatePipe } from 'app/shared/pipe/moment.pipe';
import { HasAnyAclDirective } from './auth/has-any-acl.directive';
import { ExtendedInputComponent } from './components/input/ap-extended-input.component';
import { InputMobileComponent } from './components/input/ap-input-mobile.component';
import { ConfirmResultComponent } from './components/modal/confirm-result.component';
import { ContactFormComponent } from './components/modal/contact-form.component';
import { DossierResultComponent } from './components/modal/dossier-result.component';
import { GenPasswordModalComponent } from './components/modal/gen-password-modal.component';
import { ProgPasswordModalComponent } from './components/modal/progr-password-modal.component';
import { QuestionPecPlusComponent } from './components/modal/question-pec-plus.component';
import { TwoFactorAppFlowComponent } from './components/modal/two-factor-app-flow.component';
import { VerificationCodeFormComponent } from './components/modal/verification-code-form.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { OnlyNumberDirective } from './directives/input-only-number.directive';
import { NgbdSortableHeader } from './directives/sortable.directive';
import { TextOverflowDirective } from './directives/text-overflow.directive';
import { TextTranslateAnchorDirective } from './directives/text-translate-anchor.directive';
import { EndSessionComponent } from './endSession/end-session.component';
import { FindLanguageFromKeyPipe } from './pipe/find-language-from-key.pipe';
import { SafePipe } from './pipe/safePipe';
import { AccountPanelSharedLibsModule } from './shared-libs.module';
import { ToastService } from './service/toast.service';
import { RowClickDirective } from './directives/RowClickDirective';

const sharedComponents = [
  ContactFormComponent,
  ConfirmResultComponent,
  DossierResultComponent,
  VerificationCodeFormComponent,
  ExtendedInputComponent,
  InputMobileComponent,
  TwoFactorAppFlowComponent,
  QuestionPecPlusComponent,
  GenPasswordModalComponent,
  ProgPasswordModalComponent,
  SnackbarComponent,
]

const sharedPipes = [
  FindLanguageFromKeyPipe,
  MomentDatePipe,
]
const sharedDirectives = [
  HasAnyAclDirective,
  OnlyNumberDirective,
  TextOverflowDirective,
  TextTranslateAnchorDirective,
  NgbdSortableHeader, RowClickDirective
  
]
@NgModule({
  providers: [ToastService],
  imports: [AccountPanelSharedLibsModule],
  declarations: [
    EndSessionComponent,
    SafePipe,
    ...sharedComponents,
    ...sharedPipes,
    ...sharedDirectives,
  ],
  exports: [
    AccountPanelSharedLibsModule,
    ...sharedComponents,
    ...sharedPipes,
    ...sharedDirectives,
  ]
})
export class AccountPanelSharedModule { }
